import { InjectionToken } from '@angular/core';

export const MOVIE_SITE_CUSTOM_NAVIGATION_BUTTON_TRANSLATIONS = new InjectionToken<Record<string, string>>(
  'MovieSiteCustomNavigationButtonTranslations'
);
